import type { CellContext } from '@tanstack/react-table';
import { ContentCell } from '../../components/content-cell';
import { DEFAULT_TEXT_LIST_MORE_TEXT } from '../../data-grid.constants';
import type { DataGridColumnDef, DataGridColumnDefOptions } from '../../data-grid.type';

export function getColumnDefTextList<T>(col: DataGridColumnDef<T>, options: DataGridColumnDefOptions) {
	return function TextListCell(context: CellContext<T, unknown>) {
		const value = context.getValue() as string[];
		const row = context.row.original;

		if (!value) return null;

		try {
      const [firstValue, ...additionalValues] = value;

      const primaryContent = firstValue;
      const moreContent =
				additionalValues.length > 0 ? DEFAULT_TEXT_LIST_MORE_TEXT(additionalValues.length) : undefined;
      const moreContentHover = (
				<div className="flex flex-col">
					{additionalValues.map((value, index) => (
						<div key={index} className="text-sm text-primary">
							{value}
						</div>
					))}
				</div>
			);
      
			// Use custom format if provided
			if (options?.parse) {
				const parsed = options.parse(value, row, options);

				return (
					<ContentCell
						primaryContent={parsed.primaryContent || primaryContent}
						secondaryContent={parsed.secondaryContent}
						moreContent={parsed.moreContent || moreContent}
						moreContentHover={parsed.moreContentHover || moreContentHover}
						moreContentLink={parsed.moreContentLink}
						icon={parsed.icon}
						iconOptions={parsed.iconOptions}
					/>
				);
			}

			return (
				<ContentCell primaryContent={primaryContent} moreContent={moreContent} moreContentHover={moreContentHover} />
			);
		} catch (error) {
			console.error('Error formatting datetime:', error);
			return null;
		}
	};
}
